import {
  CreateCsvFileByModificationIdCommand,
  CreateCsvFileByProjectIdCommand,
  CreateCsvFileByStackIdCommand,
  CreateSpssFileByModificationIdCommand,
  CreateSpssFileByProjectIdCommand,
  CreateSpssFileByStackIdCommand,
  CreateDatasetCsvFileByStackIdCommand,
  CreateDatasetCsvFileByModificationIdCommand,
  CreateDatasetCsvFileByProjectIdCommand,
  CreateDatasetSpssFileByModificationIdCommand,
  CreateDatasetSpssFileByStackIdCommand,
  CreateDatasetSpssFileByProjectIdCommand} from "app/ApiClient";

export interface DownLoadFilePayloadType  {
  csvByModification? : CreateCsvFileByModificationIdCommand
  csvByStack? : CreateCsvFileByStackIdCommand
  csvByProject? : CreateCsvFileByProjectIdCommand
  spssByModification? : CreateSpssFileByModificationIdCommand
  spssByStack? : CreateSpssFileByStackIdCommand
  spssByProject? : CreateSpssFileByProjectIdCommand
  datasetCsvByModification? : CreateDatasetCsvFileByModificationIdCommand
  datasetCsvByStack? : CreateDatasetCsvFileByStackIdCommand
  datasetCsvByProject? : CreateDatasetCsvFileByProjectIdCommand
  datasetSpssByModification? : CreateDatasetSpssFileByModificationIdCommand
  datasetSpssByStack? : CreateDatasetSpssFileByStackIdCommand
  datasetSpssByProject? : CreateDatasetSpssFileByProjectIdCommand
}

export default interface EncodingFilesState {
  isLoadingSpss: boolean;
  spssFailedMessage: string | null;
  spssSucceed: boolean;

  spssDownloadUrl:string;

  isLoadingCsv: boolean;
  csvFailedMessage: string | null;
  csvSucceed: boolean | null;
  csvDownloadUrl:string;

  downloadTokens: {
    [key: string]: {
      projectId: string;
      payloadUsed: DownLoadFilePayloadType
    }
  }
}

export const initialEncodingFilesState: EncodingFilesState = {
  isLoadingCsv: false,
  csvFailedMessage: null,
  csvSucceed: false,
  csvDownloadUrl: "",

  spssDownloadUrl: "",

  isLoadingSpss: false,
  spssFailedMessage: null,
  spssSucceed: false,

  downloadTokens:{}
};
